/**
 * Capitalizes the first letter of each word in the given text.
 * Converts the rest of the letters in each word to lowercase.
 * @param {string} text - The input text to be capitalized.
 * @returns {string} - The text with each word capitalized.
 */
export function capitalizeText(text) {
  const words = text.split(" ");
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toLocaleUpperCase() + word.slice(1).toLocaleLowerCase()
  );
  const capitalizedText = capitalizedWords.join(" ");
  return capitalizedText;
}

/**
 * Splits the input string at each colon (':') and removes the first segment,
 * then joins the remaining segments back into a string.
 * @param {string} stepName - The input string to be cleaned.
 * @returns {string} - The cleaned string after removing the first segment.
 */
export function renderCleanString(stepName) {
  return stepName.split(":").slice(1).join(":");
}
